module.exports = __webpack_public_path__ + "static/1-in-8-web-circle-05c3f318e9ffbb67416cd3e5f5c90d62.webp";